import React, { Component } from "react"
import TableHeaderRow from "components/common/TableHeaderRow"
import { Table } from "reactstrap"
import SystemRow from "components/system/layout/SystemRow"
import SystemFormBasic from "components/system/form/SystemFormBasic"
import { ModalActions } from "@gman/gman-redux"
import { AuthorizedAddButton } from "components/authentication/controls/AuthorizedControls"
import {
    ConfirmDelete,
    FormModal,
    Paginator,
    SpinnerOverlay
} from "@gman/gman-react-bootstrap"
import FeedbackAlert from "components/common/FeedbackAlert"
import SystemFormExtended from "components/system/form/SystemFormExtended"

const AddButton = AuthorizedAddButton(p => p.canWriteSystem)

class SystemList extends Component {

    componentDidMount() {
        this.props.recordStateEvents.onClearSearch()
    }

    componentWillUnmount = () => {
        this.props.feedbackEvents.onFlushFeedback()
    }

    render() {
        var sourceData = this.props.sourceData
        var modals = sourceData.modals
        var confirmEvents = this.props.confirmEvents
        var feedbackEvents = this.props.feedbackEvents
        var modalEvents = this.props.modalEvents
        var paginatorEvents = this.props.paginatorEvents
        var tableHeaderRowEvents = this.props.tableHeaderRowEvents
        return (
            <div>
                <FeedbackAlert {...feedbackEvents} feedback={sourceData.feedback} />
                <SpinnerOverlay isLoading={sourceData.inProgress}>
                    <div style={{ marginBottom: '75px' }}>
                        <SystemFormExtended system={sourceData.records && sourceData.records[0]} onSubmitUpdate={this.props.updateMiscMessage}/>
                    </div>

                    <Table responsive hover size="sm">
                        <thead>
                            <TableHeaderRow
                                onSortBy={tableHeaderRowEvents.onSortBy}
                                disabled={sourceData.inProgress}
                                headers={[
                                    { sortBy: "EffectiveDate", label: "Effective Date"},
                                    { sortBy: "GstRate", label: "Current GST"},
                                    { sortBy: "MileageRate", label: "Current Mileage"},
                                    { sortBy: "DailyMileageClaimLimit", label: "Current Daily Mileage Claim Limit"}
                                ]}
                            />
                        </thead>
                        <tbody>
                            {
                                sourceData.records.map((record, index) => (
                                    <SystemRow
                                        key={index}
                                        {...record}
                                        onShowDelete={() => modalEvents.onShowDelete(record)}
                                        onShowEdit={() => modalEvents.onShowEdit(record)}
                                        disabled={sourceData.inProgress} />
                                ))
                            }
                        </tbody>
                    </Table>
                    <Paginator {...paginatorEvents} searchOptions={sourceData.searchOptions} />
                    <AddButton disabled={sourceData.inProgress} onClick={() => modalEvents.onShowNew()} />
                </SpinnerOverlay>

                <FormModal
                    isVisible={ModalActions.IsDeleteVisible(modals)}
                    onHide={modalEvents.onHideDelete}
                    title={"Confirm Delete"}>
                    <ConfirmDelete onConfirmDelete={() => confirmEvents.onConfirmDelete(sourceData.recordToUpdate)} />
                </FormModal>
                <FormModal
                    isVisible={ModalActions.IsUpdateVisible(modals)}
                    onHide={modalEvents.onHideEdit}
                    title={"Update System"}>
                    <SystemFormBasic onSubmitUpdate={confirmEvents.onSubmitUpdate}
                        {...sourceData.recordToUpdate} />
                </FormModal>
            </div >
        )
    }
}

export default SystemList